import * as React from 'react'
import OrderInformation from './order_information'

export default function MoverOrderInformationApp(props) {
  return <OrderInformation {...props} />
}
